import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner, Video } from '@streamr/tv-ui';
import styled from 'styled-components';
import { MediaService } from '../../services/media/MediaService';
export const SpeakerLobby = () => {
    const mediaStreamData = MediaService.getOutput().useMediaStreamData();
    const { mediaStream, isUserFacingVideo } = mediaStreamData;
    const isVideoMuted = MediaService.getOutput().useVideoMuted();
    return (_jsx(Lobby, { children: _jsxs(LobbyContent, { children: [_jsx(ReadyText, { children: "Ready to join?" }), _jsx(CameraPreviewContainer, { children: isVideoMuted ? (_jsx(CameraDisabledContainer, { children: _jsx(CameraDisabledText, { children: "Camera disabled" }) })) : (_jsxs(_Fragment, { children: [_jsx(SpinnerContainer, { children: _jsx(Spinner, {}) }), _jsx(StyledVideo, { autoPlay: true, muted: true, playsInline: true, srcObject: mediaStream, mirror: isUserFacingVideo })] })) })] }) }));
};
const Lobby = styled.div `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--tv-ui-color-14);
    border-radius: 1rem;
`;
const LobbyContent = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
`;
const ReadyText = styled.span `
    font-size: 1.25rem;
    font-weight: 500;
    color: white;
`;
const CameraPreviewContainer = styled.div `
    position: relative;
    width: 22rem;
    height: 12rem;
    border-radius: 0.75rem;
    overflow: hidden;
`;
const SpinnerContainer = styled.div `
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const CameraDisabledContainer = styled.div `
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--tv-ui-color-14);
`;
const CameraDisabledText = styled.span `
    font-size: 1rem;
    color: var(--tv-ui-color-3);
`;
const StyledVideo = styled(Video) `
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
`;
